import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstChar',
  standalone: true,
})
export class FirstCharPipe implements PipeTransform {
  public transform(value: number | null): string {
    if (value === null) {
      return '';
    }
    if (value < 10) {
      return `0`;
    }
    return `${value}`.charAt(0);
  }
}
